module.exports = __webpack_public_path__ + "static/media/angle-double-up.54e47766.svg";